import { IState } from '../../store';

export const selectOfferUpdated = ({
  offerData: {
    offer: { humanizedEditDate, added },
  },
}: IState): string => humanizedEditDate || added;
